import efocats_validate_core from './efocats_validate_core.js';
import EFOcats_error_info from '../efocats_error_info.js';
/**
 * 必須エラーチェッククラス
 */
export default class EFOcats_validate_required extends efocats_validate_core {
  /**
   * エラーチェック
   */
  validate(checkData) {
    const material_val = checkData.val();
    const type = checkData.attr('type');

    // checkboxとradioは別のクラスでチェックするのでここでは除外
    if (type === 'checkbox' || type === 'radio') {
      return new EFOcats_error_info('success', '', '', '');
    }

    if (!material_val) {
      // 必須項目の場合
      if (checkData.parents('.check-flag').hasClass('required')) {
        return new EFOcats_error_info('error', this.langagerList('必須エラー'), 'required', '必須エラー');
      }

      // 文字数制限ありの場合で空のときに、注釈テキストを表示する
      if (checkData.parents('.inner').find('.attention-text').length > 0) {
        this.obj_show(checkData.parents('.inner').find('.attention-text'));
      }

      return new EFOcats_error_info('success', '', 'non-required', '');
    }

    return new EFOcats_error_info('success', '', '', '');
  }

  /**
   * 表示
   * @param obj
   */
  obj_show(obj) {
    obj.removeClass('hidden');
  }
}
